// extracted by mini-css-extract-plugin
export default {"mdBox":"index_mdBox_JiAch","title":"index_title_BsxnJ","sofa":"index_sofa_KLKkz","join":"index_join_ttJD0","number":"index_number_d7BbR"};